<div class='users-component'>
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Control Items Updates</h2>
    </div>
    <div style="display: flex; flex-direction: row; margin-top: 16px; margin-bottom: 10px;">
      <div *ngIf="true"
           style="margin-left: 30px; margin-top: 8px">
        <button mat-raised-button
                type="button"
                class="button"
                (click)="approveUpdates()">
          Accept Updates
        </button>
      </div>
      <div *ngIf="canManageControlItems"
           style="margin-left: 30px; margin-top: 8px">
        <button mat-raised-button
                type="button"
                class="button"
                (click)="rejectUpdates()">
          Reject Updates
        </button>
      </div>
    </div>
  </div>
  <p-table [value]="controlItems"
               #accessTable
               [rows]="100"
               [paginator]="false"
               [reorderableColumns]="true"
           dataKey="complianceAreaId"
               [metaKeySelection]="false">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 15em">Id</th>
        <th style="width: 15em">Change</th>
        <th>Description</th>
        <th style="width: 15em">Change date</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr class="ui-widget-header" *ngIf="rowGroupMetadata && rowGroupMetadata[item.complianceAreaId].index === rowIndex">
        <td colspan="4">
          <a href="#" [pRowToggler]="item">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
          </a>
          <p-checkbox (onChange)="areaSelected($event, item.complianceAreaId)"></p-checkbox>
          <span>{{item.complianceAreaName}} - {{item.comment}}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-item>
      <tr>
        <td>{{item.complianceAreaControlId}}</td>
        <td>{{item.change}}</td>
        <td>{{item.description}}</td>
        <td>{{item.date | date : "shortDate"}} {{item.date | date : "shortTime"}}</td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="msg" role="alert" class="alert alert-info alert-dismissible">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span>
    </button>
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    <span class="sr-only">Error:</span>
    {{msg}}
  </div>
</div>
